import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Player } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Player";
export const PlayerService = {
	endpoint,
	createSingle: async (data: Player) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getByTeam: async (teamId: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetByTeam/${teamId}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getHomeTeam: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetHomeTeam/`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getMyTeam: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetMyTeam/`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Player) => await Service.updateSingleById(endpoint, id, data),
}